/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateWebhookEndpointRequest,
  HttpValidationProblemDetails,
  UpdateWebhookEndpointRequest,
  WebhookEndpointDetailDto,
  WebhookEndpointSecretResult,
  WebhookEndpointSummaryDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List webhook endpoints for a client.
 */
export const adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints = (
  clientId: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointSummaryDto[]>(
    { url: `/admin/clients/${clientId}/webhook-endpoints`, method: 'GET', signal },
    options,
  );
};

export const getAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryKey = (
  clientId?: string,
) => {
  return [`/admin/clients/${clientId}/webhook-endpoints`] as const;
};

export const getAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
  >,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryKey(clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>>
  > = ({ signal }) =>
    adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints(
      clientId,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!clientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>>
  >;
export type AdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryError = unknown;

export function useAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints<
  TData = Awaited<
    ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
  >,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
          >,
          TError,
          Awaited<
            ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints<
  TData = Awaited<
    ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
  >,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
          >,
          TError,
          Awaited<
            ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints<
  TData = Awaited<
    ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
  >,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List webhook endpoints for a client.
 */

export function useAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints<
  TData = Awaited<
    ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
  >,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof adminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpoints>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions =
    getAdminWebhookEndpointsGetAdminClientsClientIdGuidWebhookEndpointsQueryOptions(
      clientId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a webhook endpoint. Returns the signing secret once.
 */
export const adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints = (
  clientId: string,
  createWebhookEndpointRequest: CreateWebhookEndpointRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointSecretResult>(
    {
      url: `/admin/clients/${clientId}/webhook-endpoints`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createWebhookEndpointRequest,
      signal,
    },
    options,
  );
};

export const getAdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpointsMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>,
    TError,
    { clientId: string; data: CreateWebhookEndpointRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>,
  TError,
  { clientId: string; data: CreateWebhookEndpointRequest },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>,
    { clientId: string; data: CreateWebhookEndpointRequest }
  > = (props) => {
    const { clientId, data } = props ?? {};

    return adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints(
      clientId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpointsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>
  >;
export type AdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpointsMutationBody =
  CreateWebhookEndpointRequest;
export type AdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpointsMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Create a webhook endpoint. Returns the signing secret once.
 */
export const useAdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>,
      TError,
      { clientId: string; data: CreateWebhookEndpointRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpoints>>,
  TError,
  { clientId: string; data: CreateWebhookEndpointRequest },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsPostAdminClientsClientIdGuidWebhookEndpointsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointDetailDto>(
    { url: `/admin/webhook-endpoints/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryKey = (id?: string) => {
  return [`/admin/webhook-endpoints/${id}`] as const;
};

export const getAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>
  > = ({ signal }) =>
    adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>
>;
export type AdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryError = unknown;

export function useAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuid<
  TData = Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminWebhookEndpointsGetAdminWebhookEndpointsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminWebhookEndpointsGetAdminWebhookEndpointsIdGuidQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid = (
  id: string,
  updateWebhookEndpointRequest: UpdateWebhookEndpointRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<WebhookEndpointDetailDto>(
    {
      url: `/admin/webhook-endpoints/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateWebhookEndpointRequest,
    },
    options,
  );
};

export const getAdminWebhookEndpointsPutAdminWebhookEndpointsIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>,
    TError,
    { id: string; data: UpdateWebhookEndpointRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>,
  TError,
  { id: string; data: UpdateWebhookEndpointRequest },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>,
    { id: string; data: UpdateWebhookEndpointRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsPutAdminWebhookEndpointsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>
>;
export type AdminWebhookEndpointsPutAdminWebhookEndpointsIdGuidMutationBody =
  UpdateWebhookEndpointRequest;
export type AdminWebhookEndpointsPutAdminWebhookEndpointsIdGuidMutationError =
  HttpValidationProblemDetails;

export const useAdminWebhookEndpointsPutAdminWebhookEndpointsIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>,
      TError,
      { id: string; data: UpdateWebhookEndpointRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsPutAdminWebhookEndpointsIdGuid>>,
  TError,
  { id: string; data: UpdateWebhookEndpointRequest },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsPutAdminWebhookEndpointsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>({ url: `/admin/webhook-endpoints/${id}`, method: 'DELETE' }, options);
};

export const getAdminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>
>;

export type AdminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuidMutationError = unknown;

export const useAdminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuid>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsDeleteAdminWebhookEndpointsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Rotate the signing secret. Returns the new secret once.
 */
export const adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointSecretResult>(
    { url: `/admin/webhook-endpoints/${id}/rotate-secret`, method: 'POST', signal },
    options,
  );
};

export const getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecretMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecretMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>
  >;

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecretMutationError = unknown;

/**
 * @summary Rotate the signing secret. Returns the new secret once.
 */
export const useAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecret>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidRotateSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointDetailDto>(
    { url: `/admin/webhook-endpoints/${id}/enable`, method: 'POST', signal },
    options,
  );
};

export const getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnableMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>
>;

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnableMutationError = unknown;

export const useAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidEnableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<WebhookEndpointDetailDto>(
    { url: `/admin/webhook-endpoints/${id}/disable`, method: 'POST', signal },
    options,
  );
};

export const getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisableMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisableMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>
>;

export type AdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisableMutationError = unknown;

export const useAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisable>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminWebhookEndpointsPostAdminWebhookEndpointsIdGuidDisableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
